import { useSelector } from 'react-redux'
import { Icon } from '../../../common/html/icon'
import { SENTIMENT_TYPE_ID } from './constant'
import { selectCompanyAlertsById } from './store/slice'

export const TypeDescription = ({ rowId }) => {
  const { sentimentId, alertCriteriaName, alertDesc } = useSelector(
    selectCompanyAlertsById(rowId),
  )

  return (
    <div className="dFlex">
      <div>
        <Icon
          className={
            sentimentId === SENTIMENT_TYPE_ID.POSITIVE
              ? 'icon-arrow-up-circle'
              : sentimentId === SENTIMENT_TYPE_ID.INFORMATIVE
              ? 'icon-info-circle'
              : 'icon-arrow-down-circle'
          }
          style={{
            fontSize: 13,
            color:
              sentimentId === SENTIMENT_TYPE_ID.INFORMATIVE
                ? '#0553A5'
                : '#E0505B',
            marginRight: 3,
          }}
        />
      </div>
      <div>
        <div
          style={{
            color:
              sentimentId === SENTIMENT_TYPE_ID.INFORMATIVE
                ? '#0553A5'
                : '#E0505B',
          }}
        >
          {alertCriteriaName}
        </div>
        <div>{alertDesc}</div>
      </div>
    </div>
  )
}
